import * as React from 'react';
import { connect } from 'react-redux';
import {
    Col,
} from 'antd';
import Registration from "./Registration";
import RegistrationImage from "../assets/images/Signup.png";
import DakarLogo from "../assets/images/daka-t-logo.png";
// import { REACT_APP_BUS_FIRST_NAME } from '../constants/StoreSetting';
// import SplashArt from "../assets/images/splash-background-curve.svg"
import BuzzTillBannerLogo from "../assets/images/buzztill-logo.png"
import { env } from '../env'
const { REACT_APP_BUS_FIRST_NAME } = env

const SignUp = () => (
 
    <div className="row m-0">
       
            <div className="col-md-6 orange-bg">
            
                <div className="sign-up-txt">
                   
                    <img alt="store-icon" className="store-img" src={BuzzTillBannerLogo} />
                    <h1 className="join-us">
                        Join 25,000+ retailers already growing their business with {REACT_APP_BUS_FIRST_NAME}
                   </h1>
                </div>

                <div className= "Signup-Reg-img">
                <img src={RegistrationImage} className="reg-img" />
                </div>

            
        </div>

        

           
                <Registration />
            

        
    </div>
        
);


export default connect()(SignUp);
